<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M1.88867 12.9999H14.1109L7.99978 2.44434L1.88867 12.9999V12.9999Z" fill="#FFD100"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M7.44336 9.11114H8.55447V6.88892H7.44336V9.11114ZM7.44336 11.3334H8.55447V10.2222H7.44336V11.3334Z" fill="#5C5C5C"/>
</svg>
